<template>
  <div class="pt40">
    <div v-if="applymentDetail.businessType == 'COMPANY_INCORPORATION' || applymentDetail.businessType == 'SERVICE_TRANSFER'">
      <el-form ref="dataForm" :model="dataForm" :rules="dataRule" label-width="120px" :disabled="disabled" :class="{ readOnlyStyle: disabled }">
        <!-- 电子发票信息 -->
        <p class="fs18 fw600 lh1em" v-if="!disabled">{{ $t("enroll.affirm.invoiceTitle") }}</p>
        <p class="fs18 fw600 lh1em" v-else>{{ $t("enroll.affirm.invoiceTitle02") }}</p>

        <div class="mt20 pt30 pb30 container tableCustom">
          <el-form-item :label="$t('enroll.affirm.invoiceName')" prop="invoiceTitle" ref="invoiceTitle">
            <el-input v-model="dataForm.invoiceTitle" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
          <el-form-item :label="$t('enroll.affirm.invoiceAddress')">
            <el-input v-model="dataForm.invoiceAddress" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
          <el-form-item :label="$t('enroll.affirm.invoiceCountry')">
            <el-select v-model="dataForm.invoiceCountry" :placeholder="$t('common.placeholder.select')" filterable class="wdb100" clearable>
              <el-option v-for="item in globalFormatList('countryList')" :key="`country-${item.value}`" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('enroll.affirm.invoiceCode')" class="mb0">
            <el-input v-model="dataForm.invoicePostalCode" :placeholder="$t('common.placeholder.enter')" v-regexFilter="$halfWidthRegex" class="wdb100"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { validateLocation } from "@/utils/common";
import validatorMixin from "@/mixins/validatorMixin";
import { mapState, mapGetters } from "vuex";
export default {
  mixins: [validatorMixin],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataForm: {
        invoiceTitle: "",
        invoiceAddress: "",
        invoiceCountry: "",
        invoicePostalCode: "",
      },
      dataRule: {
        invoiceTitle: [
          {
            required: true,
            message: this.$t("common.placeholder.enter"),
            trigger: "submit",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("applyment", ["applymentDetail"]),
    ...mapGetters("language", ["getLanguage"]),
    ...mapGetters("constant", ["globalFormatList"]),
  },
  methods: {
    // 初始化
    async init() {
      const applymentDetailCopy = JSON.parse(JSON.stringify(this.applymentDetail));
      const { invoiceTitle = "", invoiceAddress = "", invoiceCountry = "", invoicePostalCode = "" } = applymentDetailCopy;
      this.dataForm = {
        invoiceTitle,
        invoiceAddress,
        invoiceCountry,
        invoicePostalCode,
      };
    },
    // 获取提交参数(由父级触发)
    getParamsData() {
      return this.dataForm;
    },
    // 提交表单(由父级触发)
    dataFormSubmit() {
      return new Promise((resolve, reject) => {
        if (this.$refs["dataForm"]) {
          this.$refs["dataForm"].validate((valid, object) => {
            if (valid) {
              resolve();
            } else {
              validateLocation(object, this);
              reject("custom prompt: Form verification failed");
            }
          });
        } else {
          resolve();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tableCustom {
  ::v-deep {
    .el-form-item {
      background: #f9fafc !important;
    }

    .el-form-item__content {
      border-bottom: 1px solid #e8edf6;
      border-right: 1px solid #e8edf6;
      height: 60px;
      line-height: 60px;
    }

    .el-form-item__label {
      text-align: center;
      color: #011a45;
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #e8edf6;
      border-right: 1px solid #e8edf6;
      border-left: 1px solid #e8edf6;
    }

    .el-form-item:first-child .el-form-item__label {
      border-top: 1px solid #e8edf6;
    }

    .el-form-item:first-child .el-form-item__content {
      border-top: 1px solid #e8edf6;
    }

    .el-form-item {
      margin-bottom: 0px;
    }

    .el-input__inner {
      height: 20px;
      line-height: 20px;
      border: none;
      background: #f9fafc;
    }

    .el-form-item__content .el-form-item__error {
      left: 15px;
      margin-top: -17px;
      padding-top: 0px;
    }
  }
}
</style>
